export default [
  {
    path: "/recommend",
    name: "recommend",
    component: (resolve) => require(["@/views/PCView/recommend/index.vue"], resolve),
  },
];
